
// You can write more code here

/* START OF COMPILED CODE */

import CarouselComponent from "../components/core/CarouselComponent";
import CharacterBreathe from "../components/game/CharacterBreathe";
import BtnCarouselArrowRight from "../prefabs/btns/BtnCarouselArrowRight";
import UIPositionContainer from "../components/core/UIPositionContainer";
import BtnCarouselArrowLeft from "../prefabs/btns/BtnCarouselArrowLeft";
import UIButton from "../components/core/UIButton";
import BtnBack from "../prefabs/btns/BtnBack";
import BtnAudio from "../prefabs/btns/BtnAudio";
import FitTextToBounds from "../components/core/FitTextToBounds";
import LocaliseText from "../components/core/LocaliseText";
/* START-USER-IMPORTS */
import { BaseScene } from '@scarybeasties/phaser-framework-core/scenes';
import { Sounds } from '../sounds';
import {GameSceneData, SceneData, TransitionPoint} from '../app-routing';
import { GameDataHandler } from '../game/GameDataHandler';
import {LevelName, LevelNameValues} from './../game/levels/level';
import Tween = Phaser.Tweens.Tween;
import {RunSettings} from "~/js/game/RunSettingsHandler";
/* END-USER-IMPORTS */

export default class CharacterSelect extends BaseScene {

  constructor() {
    super("CharacterSelect");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    this.add.image(960, 384, "character-select", "bg-charselect.jpg");

    // characters
    const characters = this.add.container(960, 713);
    characters.name = "characters";

    // BugsBunny
    const bugsBunny = this.add.container(0, 0);
    bugsBunny.name = "BugsBunny";
    characters.add(bugsBunny);

    // spotlight
    const spotlight = this.add.image(-28, -44, "character-select", "spotlight.png");
    bugsBunny.add(spotlight);

    // BugsBunny_img
    const bugsBunny_img = this.add.image(0, 0, "character-select", "char-bugs.png");
    bugsBunny_img.setOrigin(0.5, 1);
    bugsBunny.add(bugsBunny_img);

    // MarvinMartian
    const marvinMartian = this.add.container(378, -1);
    marvinMartian.name = "MarvinMartian";
    characters.add(marvinMartian);

    // spotlight_1
    const spotlight_1 = this.add.image(-25, -39, "character-select", "spotlight.png");
    marvinMartian.add(spotlight_1);

    // MarvinMartian_img
    const marvinMartian_img = this.add.image(0, 0, "character-select", "char-marvin.png");
    marvinMartian_img.setOrigin(0.5, 1);
    marvinMartian.add(marvinMartian_img);

    // YosemiteSam
    const yosemiteSam = this.add.container(756, -3);
    yosemiteSam.name = "YosemiteSam";
    characters.add(yosemiteSam);

    // spotlight_2
    const spotlight_2 = this.add.image(19, -36, "character-select", "spotlight.png");
    yosemiteSam.add(spotlight_2);

    // YosemiteSam_img
    const yosemiteSam_img = this.add.image(0, 0, "character-select", "char-yosemitesam.png");
    yosemiteSam_img.setOrigin(0.5, 1);
    yosemiteSam.add(yosemiteSam_img);

    // PorkyPig
    const porkyPig = this.add.container(1134, -1);
    porkyPig.name = "PorkyPig";
    characters.add(porkyPig);

    // spotlight_3
    const spotlight_3 = this.add.image(3, -32, "character-select", "spotlight.png");
    porkyPig.add(spotlight_3);

    // PorkyPig_img
    const porkyPig_img = this.add.image(0, 0, "character-select", "char-porkypig.png");
    porkyPig_img.setOrigin(0.5, 1);
    porkyPig.add(porkyPig_img);

    // TweetyBird
    const tweetyBird = this.add.container(1512, -1);
    tweetyBird.name = "TweetyBird";
    characters.add(tweetyBird);

    // spotlight_4
    const spotlight_4 = this.add.image(-8, -27, "character-select", "spotlight.png");
    tweetyBird.add(spotlight_4);

    // TweetyBird_img
    const tweetyBird_img = this.add.image(0, 0, "character-select", "char-tweety.png");
    tweetyBird_img.setOrigin(0.5, 1);
    tweetyBird.add(tweetyBird_img);

    // RoadRunner
    const roadRunner = this.add.container(1890, -1);
    roadRunner.name = "RoadRunner";
    characters.add(roadRunner);

    // spotlight_5
    const spotlight_5 = this.add.image(1, -22, "character-select", "spotlight.png");
    roadRunner.add(spotlight_5);

    // RoadRunner_img
    const roadRunner_img = this.add.image(0, 0, "character-select", "char-roadrunner.png");
    roadRunner_img.setOrigin(0.5, 1);
    roadRunner.add(roadRunner_img);

    // btnCarouselArrowRight
    const btnCarouselArrowRight = new BtnCarouselArrowRight(this, 1887, 384);
    this.add.existing(btnCarouselArrowRight);

    // btnCarouselArrowLeft
    const btnCarouselArrowLeft = new BtnCarouselArrowLeft(this, 0, 384);
    this.add.existing(btnCarouselArrowLeft);

    // btnPlayLevel
    const btnPlayLevel = this.add.container(1807, 667);

    // btn_play_png
    const btn_play_png = this.add.image(0, 0, "common", "btn-top-ui-right-green.png");
    btnPlayLevel.add(btn_play_png);

    // btn_play_png_1
    const btn_play_png_1 = this.add.image(6, -4, "common", "icon-tick.png");
    btnPlayLevel.add(btn_play_png_1);

    // btnBack
    const btnBack = new BtnBack(this, 84, 84);
    this.add.existing(btnBack);

    // btnAudio
    const btnAudio = new BtnAudio(this, 1836, 84);
    this.add.existing(btnAudio);

    // Title
    const title = this.add.container(960, 80);

    // label
    const label = this.add.text(0, 0, "", {});
    label.setOrigin(0.5, 0.5);
    label.text = "New text";
    label.setStyle({ "color": "#f6f45a", "fontFamily": "Acme-Regular", "fontSize": "70px", "shadow.offsetY":4,"shadow.fill":true});
    label.setPadding({"left":10,"top":10,"right":10,"bottom":10});
    title.add(label);

    // powerupHolder
    const powerupHolder = this.add.container(1051, 686);

    // bg
    const bg = this.add.image(149, 2, "character-select", "container.png");
    powerupHolder.add(bg);

    // powerup-label
    const powerup_label = this.add.text(49, 3, "", {});
    powerup_label.name = "powerup-label";
    powerup_label.setOrigin(0, 0.5);
    powerup_label.text = "New text";
    powerup_label.setStyle({ "fontFamily": "Acme-Regular", "fontSize": "50px", "shadow.offsetX":5,"shadow.offsetY":5,"shadow.color": "#00000075", "shadow.fill":true});
    powerup_label.setPadding({"left":10,"top":10,"right":10,"bottom":10});
    powerupHolder.add(powerup_label);

    // powerup-icon
    const powerup_icon = this.add.image(0, 2, "character-select", "icon-roadrunner.png");
    powerup_icon.name = "powerup-icon";
    powerupHolder.add(powerup_icon);

    // lists
    const characterList = [bugsBunny, marvinMartian, yosemiteSam, porkyPig, tweetyBird, roadRunner];

    // characters (components)
    const charactersCarouselComponent = new CarouselComponent(characters);
    charactersCarouselComponent.CarouselList = characterList;
    charactersCarouselComponent.infiniteCarousel = true;

    // bugsBunny_img (components)
    new CharacterBreathe(bugsBunny_img);

    // marvinMartian_img (components)
    new CharacterBreathe(marvinMartian_img);

    // yosemiteSam_img (components)
    new CharacterBreathe(yosemiteSam_img);

    // porkyPig_img (components)
    new CharacterBreathe(porkyPig_img);

    // tweetyBird_img (components)
    new CharacterBreathe(tweetyBird_img);

    // roadRunner_img (components)
    new CharacterBreathe(roadRunner_img);

    // btnCarouselArrowRight (components)
    const btnCarouselArrowRightUIPositionContainer = new UIPositionContainer(btnCarouselArrowRight);
    btnCarouselArrowRightUIPositionContainer.offsetX = 20;
    btnCarouselArrowRightUIPositionContainer.PinRight = true;

    // btnCarouselArrowLeft (components)
    const btnCarouselArrowLeftUIPositionContainer = new UIPositionContainer(btnCarouselArrowLeft);
    btnCarouselArrowLeftUIPositionContainer.offsetX = 20;
    btnCarouselArrowLeftUIPositionContainer.PinLeft = true;

    // btnPlayLevel (components)
    const btnPlayLevelUIButton = new UIButton(btnPlayLevel);
    btnPlayLevelUIButton.shouldPulse = true;
    btnPlayLevelUIButton.pulseDelay = 6000;
    btnPlayLevelUIButton.pulseRepeat = true;
    const btnPlayLevelUIPositionContainer = new UIPositionContainer(btnPlayLevel);
    btnPlayLevelUIPositionContainer.offsetX = 20;
    btnPlayLevelUIPositionContainer.offsetY = 20;
    btnPlayLevelUIPositionContainer.PinRight = true;
    btnPlayLevelUIPositionContainer.PinToBottom = true;

    // btnBack (components)
    const btnBackUIPositionContainer = new UIPositionContainer(btnBack);
    btnBackUIPositionContainer.offsetX = 24;
    btnBackUIPositionContainer.offsetY = 24;
    btnBackUIPositionContainer.PinLeft = true;
    btnBackUIPositionContainer.PinTop = true;

    // btnAudio (components)
    const btnAudioUIPositionContainer = new UIPositionContainer(btnAudio);
    btnAudioUIPositionContainer.offsetX = 24;
    btnAudioUIPositionContainer.offsetY = 24;
    btnAudioUIPositionContainer.PinRight = true;
    btnAudioUIPositionContainer.PinTop = true;

    // label (components)
    const labelFitTextToBounds = new FitTextToBounds(label);
    labelFitTextToBounds.maxWidth = 800;
    labelFitTextToBounds.constrainByWidth = true;
    const labelLocaliseText = new LocaliseText(label);
    labelLocaliseText.copyId = "characterSelect";

    // powerup_label (components)
    const powerup_labelFitTextToBounds = new FitTextToBounds(powerup_label);
    powerup_labelFitTextToBounds.maxWidth = 280;
    powerup_labelFitTextToBounds.constrainByWidth = true;
    new LocaliseText(powerup_label);

    this.characters = characters;
    this.btnCarouselArrowRight = btnCarouselArrowRight;
    this.btnCarouselArrowLeft = btnCarouselArrowLeft;
    this.btnPlayLevel = btnPlayLevel;
    this.btnBack = btnBack;
    this.btnAudio = btnAudio;
    this.powerupHolder = powerupHolder;
    this.powerup_label = powerup_label;
    this.powerup_icon = powerup_icon;
    this.characterList = characterList;

    this.events.emit("scene-awake");
  }

  private characters!: Phaser.GameObjects.Container;
  private btnCarouselArrowRight!: BtnCarouselArrowRight;
  private btnCarouselArrowLeft!: BtnCarouselArrowLeft;
  private btnPlayLevel!: Phaser.GameObjects.Container;
  private btnBack!: BtnBack;
  private btnAudio!: BtnAudio;
  private powerupHolder!: Phaser.GameObjects.Container;
  private powerup_label!: Phaser.GameObjects.Text;
  private powerup_icon!: Phaser.GameObjects.Image;
  private characterList!: Phaser.GameObjects.Container[];

  /* START-USER-CODE */
  private carouselIndex:integer = 0;
  private carouselTween!:Tween;
  private sceneData!: SceneData;
  private gameSceneData!: GameSceneData;
  private runSettings!: RunSettings;
  private carousel!:CarouselComponent;
  private idleTimer!:Phaser.Time.TimerEvent;

  create() {
    super.create();
    this.editorCreate();

    this.btnPlayLevel.on(UIButton.events.clicked,this.startLevel,this);
    this.carousel = CarouselComponent.getComponent(this.characters);
    if(this.carousel !== undefined) {
      console.log(this.carousel);
      this.btnCarouselArrowLeft.on(UIButton.events.clicked, this.carousel.moveCarouselLeft, this.carousel);
      this.btnCarouselArrowRight.on(UIButton.events.clicked, this.carousel.moveCarouselRight, this.carousel);
    }

    let selected = GameDataHandler.getLastCharacterPlayed(this);
    if(selected == "")
    {
      console.log("Spin carousel");
      this.carousel.spinToIndex( Phaser.Math.Between(0,this.characterList.length-1),true);
    }
    else
    {
      for(let i = 0; i < this.characterList.length; ++i)
      {
        if(this.characterList[i].name == selected)
        {
          this.carousel.moveToIndex(i,false);
        }
      }
    }

    this.powerupHolder.alpha = 0;

    this.events.on("carouselLanded",this.handleCarouselLanded,this);
    this.events.on("carouselMoved",this.handleCarouselMoved,this);
    this.btnBack.once(UIButton.events.clicked, this.back, this);

  }

  init(data: SceneData) {
    super.init(data);
    this.sceneData = data;

    let gameSceneDataDefaults: GameSceneData = {
      shouldSkip: false
    };

    let runSettingsDefaults: RunSettings = {
      selectedLevel: LevelName.Level1,
      instantRestart: false,
      regenOnRestart: true
    };

    this.runSettings = Object.assign({}, runSettingsDefaults, data.runSettings);
    this.idleTimer?.remove();
    // this.idleTimer = this.time.delayedCall(6000, this.pulseRandomLevel, undefined, this);
  }

  public back() {
    this.app.App.gotoNextScene(this, TransitionPoint.CharacterSelectBack);
    this.btnPlayLevel.off(UIButton.events.clicked,this.startLevel,this);
  }

  handleCarouselMoved()
  {
    this.add.tween({
      targets:[this.powerupHolder],
      alpha:0,
      duration:200,
      ease:Phaser.Math.Easing.Quadratic.InOut,
    });

  }

  handleCarouselLanded(item: Phaser.GameObjects.Container | Phaser.GameObjects.Image | undefined)
  {
    this.powerup_icon.setTexture("character-select","icon-"+this.characterList[this.carousel.CurrentIndex].name.toLowerCase()+".png");
    LocaliseText.getComponent(this.powerup_label).changeText(this.characterList[this.carousel.CurrentIndex].name.toLowerCase()+"Powerup");
    this.add.tween({
      targets:[this.powerupHolder],
      alpha:1,
      duration:200,
      ease:Phaser.Math.Easing.Quadratic.InOut,
    });
  }

  startLevel()
  {
    let characterSFX:string = this.characterList[this.carousel.CurrentIndex].name.toLowerCase() + "_carousel";
    this.app.AudioHandler.playSound(this, characterSFX, Sounds.Channel.SFX, {
      volume:1
    });

    this.carousel.canScale = false;
    this.add.tween({
      targets:this.characterList[this.carousel.CurrentIndex],
      scale:1.1,
      yoyo:true,
      duration:100,
      ease:Phaser.Math.Easing.Quadratic.InOut,
    });


    this.btnPlayLevel.off(UIButton.events.clicked,this.startLevel,this);
    GameDataHandler.updateSelectedCharacter(this,this.characterList[this.carousel.CurrentIndex].name);


    this.add.tween({
      targets: [this.btnPlayLevel,this.btnBack,this.btnCarouselArrowLeft,this.btnCarouselArrowRight],
      alpha: 0,
      duration: 300,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.time.addEvent({
      delay:400,
      callback:()=>{
        if (!this.sceneData.runSettings) this.sceneData.runSettings = {};
        this.sceneData.runSettings.selectedLevel = this.runSettings.selectedLevel;
        this.app.App.gotoNextScene(this, TransitionPoint.CharacterSelectEnd, this.sceneData);
      }
    });
  }

  // private pulseRandomLevel()
  // {
  //   UIButton.getComponent(this.btnPlayLevel).manualPulse();
  //   this.idleTimer?.remove();
  //   this.idleTimer = this.time.delayedCall(6000, this.pulseRandomLevel, undefined, this);
  // }

  update(time: number, delta: number) {
    super.update(time, delta);
  }

  shutdown() {
    super.shutdown();
    this.btnCarouselArrowLeft.off(UIButton.events.clicked, this.carousel.moveCarouselLeft, this.carousel);
    this.btnCarouselArrowRight.off(UIButton.events.clicked, this.carousel.moveCarouselRight, this.carousel);
    this.btnPlayLevel.off(UIButton.events.clicked,this.startLevel,this);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
